import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import logo from "../../assets/logo.svg"
import { Home } from '@mui/icons-material';
import { useHistory } from 'react-router-dom';

const pages = ['Wallet', 'Buy & Sell', 'Earn', 'Setting'];
const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

const AppNav = ({firstItem}) => {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const history = useHistory()

    return (
        <AppBar position="static" sx={{ bgcolor: "#fff" }} elevation={0}>
            <Container maxWidth="lg">
                <Toolbar disableGutters >
                    <img src={logo} width={"70px"} onClick={()=> history.push("/")} />

                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                       
                    </Box>
                    <Typography
                        variant="h5"
                        noWrap
                        component="a"
                        href=""
                        sx={{
                            mr: 2,
                            display: { xs: 'flex', md: 'none' },
                            flexGrow: 1,
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.3rem',
                            color: 'inherit',
                            textDecoration: 'none',
                        }}
                    >
                        LOGO
                    </Typography>
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        {firstItem.map((page, idx) => (
                            <Button
                                key={idx}
                                onClick={()=> history.push(page.to)}
                                sx={{ my: 2, mr: 2, color: "#929FA4", display: 'block' }}
                            >
                                {page.name}
                            </Button>
                        ))}
                    </Box>

                    <Box sx={{ flexGrow: 0, }}>
                    <Box sx={{ display: { xs: 'none', md: 'block', }}}>
                        <Button  onClick={() => history.push("/")} size='large' startIcon={<Home sx={{ color: "#F1F2FA", }} />} variant="contained" sx={{
                            bgcolor: "#fff", color: "#455A64", '&:hover': {
                                backgroundColor: '#fff',
                                color: "#000",


                            },
                           
                        }}>
                            Back to e7.com

                        </Button>
                        </Box>
                        
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            sx={{display: { xs: 'block', md: 'none', }}}
                            onClick={handleOpenNavMenu}
                            
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >
                            {firstItem.map((page, idx) => (
                                <MenuItem key={idx} onClick={handleCloseNavMenu}>
                                    <Typography textAlign="center">{page.name}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>

                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
};
export default AppNav;
